<div class="bonus-reward">
  <div class="bonus-reward__pointer">
    <img src="assets/images/svg-icons/bonus-reward/pointer-arrow.svg" alt="" />
  </div>

  <div class="bonus-reward__content">
    <div class="bonus-reward__header">
      <div class="bonus-reward__title-group">
        <img class="bonus-reward__icon-26" src="assets/images/svg-icons/bonus-reward/gift-icon.svg" alt="" />
        <p class="bonus-reward__title">{{ 'bonus_reward.title' | translate }}</p>
      </div>
      <img
        class="bonus-reward__close"
        src="assets/images/svg-icons/bonus-reward/close-icon.svg"
        alt="Close"
        role="button"
        (click)="onClose()"
      />
    </div>

    <p class="bonus-reward__subtitle">
      {{ 'bonus_reward.subtitle_text' | translate }}
      <span class="bonus-reward__accent-cyan">{{ 'bonus_reward.subtitle_highlight' | translate }}</span>
    </p>

    <div class="bonus-reward__divider"></div>

    <div class="bonus-reward__row">
      <div class="bonus-reward__table">
        <div class="bonus-reward__table-header">
          <p>{{ 'bonus_reward.table_header_amount' | translate }}</p>
          <p>{{ 'bonus_reward.table_header_bonus' | translate }}</p>
        </div>

        @for (tier of tiers; track tier.amountKey) {
          <div class="bonus-reward__tier-row">
            <div class="bonus-reward__amount-group">
              <img class="bonus-reward__icon-18" src="assets/images/svg-icons/bonus-reward/hex-icon.svg" alt="" />
              <p class="bonus-reward__amount">{{ tier.amountKey | translate }}</p>
            </div>
            <p class="bonus-reward__bonus-value">{{ tier.bonusKey | translate }}</p>
          </div>
        }
      </div>

      <div class="bonus-reward__vdivider"></div>

      <div class="bonus-reward__example">
        <div class="bonus-reward__section-header">
          <img class="bonus-reward__icon-21" src="assets/images/svg-icons/bonus-reward/star-icon.svg" alt="" />
          <p class="bonus-reward__section-title">{{ 'bonus_reward.example_title' | translate }}</p>
        </div>

        <p class="bonus-reward__body-text">{{ 'bonus_reward.example_purchase' | translate }}</p>
        <p class="bonus-reward__label-text">{{ 'bonus_reward.example_receive_label' | translate }}</p>

        <ul class="bonus-reward__bullet-list">
          <li>
            <span class="bonus-reward__bullet">&bull;</span>
            <span>{{ 'bonus_reward.example_bullet_1' | translate }}</span>
          </li>
          <li>
            <span class="bonus-reward__bullet">&bull;</span>
            <span>
              <span class="bonus-reward__accent-lime">{{ 'bonus_reward.example_bullet_2_amount' | translate }}</span>
              {{ 'bonus_reward.example_bullet_2_text' | translate }}
              <span class="bonus-reward__accent-cyan">{{ 'bonus_reward.example_bullet_2_percent' | translate }}</span>
            </span>
          </li>
        </ul>

        <div class="bonus-reward__total-box">
          <p class="bonus-reward__total-label">{{ 'bonus_reward.total_label' | translate }}</p>
          <div class="bonus-reward__total-value-row">
            <p class="bonus-reward__total-value">{{ 'bonus_reward.total_value' | translate }}</p>
            <img class="bonus-reward__icon-35" src="assets/images/svg-icons/bonus-reward/token-icon.png" alt="" />
          </div>
        </div>
      </div>
    </div>

    <div class="bonus-reward__divider"></div>

    <div class="bonus-reward__row">
      <div class="bonus-reward__important">
        <div class="bonus-reward__section-header">
          <img class="bonus-reward__icon-21" src="assets/images/svg-icons/bonus-reward/info-icon.svg" alt="" />
          <p class="bonus-reward__section-title">{{ 'bonus_reward.important_title' | translate }}</p>
        </div>
        <p class="bonus-reward__body-text">
          {{ 'bonus_reward.important_text' | translate }}
          <span class="bonus-reward__accent-cyan">{{ 'bonus_reward.important_highlight' | translate }}</span>
          {{ 'bonus_reward.important_text_end' | translate }}
        </p>
      </div>

      <div class="bonus-reward__vdivider"></div>

      <div class="bonus-reward__checklist">
        <p class="bonus-reward__label-text">{{ 'bonus_reward.checklist_example_label' | translate }}</p>

        <div class="bonus-reward__checklist-items">
          <div class="bonus-reward__check-row">
            <img class="bonus-reward__icon-20" src="assets/images/svg-icons/bonus-reward/check-icon.svg" alt="" />
            <p class="bonus-reward__body-text">{{ 'bonus_reward.checklist_check_text' | translate }}</p>
          </div>
          <div class="bonus-reward__x-row">
            <img class="bonus-reward__icon-20" src="assets/images/svg-icons/bonus-reward/x-icon.svg" alt="" />
            <div class="bonus-reward__x-text-col">
              <p class="bonus-reward__body-text">{{ 'bonus_reward.checklist_x_text' | translate }}</p>
              <p class="bonus-reward__muted-text">{{ 'bonus_reward.checklist_x_subtext' | translate }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="bonus-reward__divider"></div>

    <div class="bonus-reward__footer">
      <img class="bonus-reward__icon-19" src="assets/images/svg-icons/bonus-reward/shield-icon.svg" alt="" />
      <p class="bonus-reward__label-text">{{ 'bonus_reward.footer_text' | translate }}</p>
    </div>
  </div>
</div>
